{
  "table": {
    "key": "Clé",
    "ticker": "Symbole",
    "name": "Nom",
    "exchange": "Change",
    "currency": "Devise",
    "currentPrice": "Prix actuel (CAD)",
    "originalCurrency": "Devise originale",
    "originalPrice": "Prix original",
    "primaryAssetClass": "Catégorie d'actifs primaires",
    "secondaryAssetClass": "Catégorie d'actifs secondaires",
    "substituteProduct": "Substitut",
    "description": "Description",
    "tradeSchedule": "Calendrier des opérations",
    "planned": "Planifié",
    "noSchedule": "Aucun calendrier",
    "taxRank": "Rang d'imposition",
    "autoUpdatePrices": "Mettre à jour les prix automatiquement",
    "fundSeries": "Série de fonds",
    "yes": "Oui",
    "no": "Non",
    "unselectAll": "Désélectionner tout",
    "selectAll": "Sélectionner tout",
    "selectAllMessage": "Nombre total de lignes sélectionnées: <bold>{{rowsCount}}</bold>.",
    "cusip": "CUSIP",
    "fractional": "Fractionnel",
    "volatile": "Volatile",
    "tertiaryAssetClass": "Classe d'actif tertiaire",
    "waivedFeePercentage": "Pourcentage d'exemption de frais",
    "settlementDays": "Jours de règlement",
    "url": "URL",
    "isin": "ISIN",
    "ric": "RIC",
    "type": "Type",
    "multiplier": "Multiplicateur",
    "allTypes": {
      "CASH_EQUIVALENTS": "Équivalents en espèces",
      "FIXED_INCOME": "Revenu fixe",
      "EQUITY": "Capitaux propres",
      "MUTUAL_FUND": "Fonds communs de placement",
      "ETF": "ETF",
      "DERIVATIVES": "Produits dérivés",
      "ALTERNATIVE_INVESTMENTS": "Investissements alternatifs",
      "ANNUITY": "Rente",
      "CURRENCY": "Devise",
      "OTHER": "Autre"
    },
    "currencyCurrentPriceCAD": "Prix actuel (CAD)",
    "currencyCurrentPriceUSD": "Prix actuel (USD)"
  },
  "productModal": {
    "editTitle": "Modifier le produit",
    "title": "Ajouter à la gamme de produits",
    "ticker": "Symbole",
    "name": "Nom",
    "exchange": "Change",
    "originalCurrency": "Devise originale",
    "displayCurrency": "Afficher la devise",
    "primaryAssetClass": "Catégorie d'actifs primaires",
    "secondaryAssetClass": "Catégorie d'actifs secondaires",
    "tertiaryAssetClass": "Classe d'actif tertiaire",
    "substituteProduct": "Produit financier de remplacement",
    "autoUpdatePrices": "Mettre à jour les prix automatiquement",
    "organization": "Organisation",
    "currentPrice": "Prix actuel",
    "schedule": "Calendrier",
    "illiquidMessage": "Ajouter un calendrier d'opération",
    "nextDate": "Date suivante",
    "waivedFeePercentage": "Pourcentage d'exemption de frais (0 - 100 %)",
    "taxRank": "Rang d'imposition",
    "volatile": "Volatile",
    "settlementDays": "Jours de règlement",
    "archive": "Archive",
    "newProductToastMessage": "Vous avez ajouté un produit financier",
    "updateProductToastMessage": "Vous avez mis à jour un produit financier",
    "archiveToastMessage": "Vous avez archivé un produit financier",
    "url": "URL",
    "isPartial": "Fractionnel",
    "download": "Télécharger l'historique des prix",
    "noHistoryToastMessage": "{{ticker}} n'a pas d'historique des prix",
    "cusip": "CUSIP",
    "isin": "ISIN",
    "ric": "RIC",
    "alphaNumericErrorMessage": "Seuls les caractères alphanumériques sont autorisés.",
    "alphaNumericWithDotErrorMessage": "Seuls les caractères alphanumériques, éventuellement séparés par un point, sont autorisés.",
    "zeroMultiplierErrorMessage": "Le multiplicateur ne doit pas être égal à zéro.",
    "cusipLengthErrorMessage": "9 ou 22 caractères sont requis.",
    "type": "Type",
    "fundSeries": "Série de fonds",
    "allTypes": {
      "CASH_EQUIVALENTS": "Équivalents en espèces",
      "FIXED_INCOME": "Revenu fixe",
      "EQUITY": "Capitaux propres",
      "MUTUAL_FUND": "Fonds communs de placement",
      "ETF": "ETF",
      "DERIVATIVES": "Produits dérivés",
      "ALTERNATIVE_INVESTMENTS": "Investissements alternatifs",
      "ANNUITY": "Rente",
      "CURRENCY": "Devise",
      "OTHER": "Autre"
    },
    "multiplier": "Multiplicateur",
    "currencyWarningMessage": "Avertissement : La devise originale ({{originalCurrency}}) diffère de la devise par défaut de la bourse ({{exchangeCurrency}}).",
    "isinLengthErrorMessage": "12 caractères sont requis.",
    "duplicateProductErrorMessage": "Ce produit existe déjà. Veuillez sélectionner une combinaison différente de symbole, de bourse ou d'organisation.",
    "originalPrice": "Prix original",
    "currencyCurrentPriceCAD": "Prix actuel (CAD)",
    "currencyCurrentPriceUSD": "Prix actuel (USD)"
  },
  "assetClassModal": {
    "editTitle": "Modifier la catégorie d'actifs",
    "title": "Créer une nouvelle catégorie d'actifs",
    "key": "Clé",
    "name": "Nom",
    "description": "Description",
    "archive": "Archive",
    "newAssetClassToastMessage": "Vous avez ajouté une catégorie d'actifs",
    "archiveToastMessage": "Vous avez archivé une catégorie d'actifs"
  },
  "newGoalModal": {
    "title": "Ajouter un nouvel objectif"
  },
  "filters": {
    "isScheduled": "Planifié",
    "hasSubstitute": "comporte des produits de remplacement",
    "primaryAssetClass": "Catégorie d'actifs primaires",
    "exchange": "Change",
    "secondaryAssetClass": "Catégorie d'actifs secondaires",
    "moreFilters": "Filtres",
    "clearFilters": "Effacer les filtres",
    "autoUpdatePrices": "Mettre à jour les prix automatiquement"
  },
  "holdingDetailView": "Vue détaillée du placement",
  "tabs": {
    "details": "Détails",
    "auditLog": "Journal d'audit"
  },
  "auditLog": {
    "searchByProduct": "Rechercher par produit",
    "startDate": "Date de début",
    "endDate": "Date de fin",
    "emptyState": "Appliquez au moins un filtre pour afficher les journaux d'audit",
    "errorLoading": "Impossible de charger le journal d'audit",
    "invalidDateRange": "La date de fin doit être égale ou postérieure à la date de début.",
    "clearDates": "Effacer les dates"
  }
}
